import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../ApiProvider';
import { unwrap } from '../client';
import type { components } from '../schema.gen';
import { queryKeys } from './keys';

export type Role = components['schemas']['Role'];

/**
 * The optional roles switched on in Settings (ADR 0018, ADR 0028), for the screens that
 * offer roles: admins and pay viewers only. Saving roles in Settings refetches it.
 */
export function useEnabledRoles() {
  const api = useApiClient();
  return useQuery({
    queryKey: queryKeys.roles(),
    queryFn: () => unwrap(api.GET('/api/roles')),
    select: (roles) => roles.enabledRoles,
  });
}
